import { Direction, Displaying, Spacing } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";
import { useState } from "react";
import type { NegativeFeedbackReasonEnum } from "../../../../../enums/negative-feedback-reason.enum";
import { NEGATIVE_FEEDBACK_REASON_MAPPING, negativeFeedbackReasons } from "../../ai-response-feedback.const";
import { AiResponseFeedbackChip } from "./ai-response-feedback-chip";

interface AiResponseFeedbackReasonsChipsProps {
  onReasonClick: (reason: NegativeFeedbackReasonEnum) => void;
}

const REASON_CHIP_ID_PREFIX = "reason-chip";

export function AiResponseFeedbackReasonsChips({
  onReasonClick,
}: Readonly<AiResponseFeedbackReasonsChipsProps>): JSX.Element {
  const [selectedReason, setSelectedReason] = useState<NegativeFeedbackReasonEnum | null>(null);

  function handleReasonClick(reason: NegativeFeedbackReasonEnum) {
    onReasonClick(reason);
  }

  return (
    <Box display={Displaying.flex} flexDirection={Direction.row} gap={Spacing["500"]} flexWrap="wrap">
      {negativeFeedbackReasons.map(function displayReasonChip(reason: NegativeFeedbackReasonEnum) {
        const isSelected = selectedReason === reason;
        const chipVariant = isSelected ? "filled" : "outlined";
        const reasonChipId = `${REASON_CHIP_ID_PREFIX}-${reason}`.toLowerCase();

        return (
          <AiResponseFeedbackChip
            id={reasonChipId}
            key={reason}
            selected={isSelected}
            variant={chipVariant}
            label={NEGATIVE_FEEDBACK_REASON_MAPPING[reason]}
            onClick={function onReasonChipClick() {
              if (selectedReason === null) {
                setSelectedReason(reason);
                setTimeout(() => {
                  handleReasonClick(reason);
                }, 300);
              }
            }}
          />
        );
      })}
    </Box>
  );
}
